import "./AppNavbar.scss";
import React from "react";
import {Nav, Navbar} from "react-bootstrap";
import logo from '../../../assets/images/Logo-Login@2x.png'

export default function AppNavbar({setToken, roles, setRoles, setAccountId}) {

    return (
        <div  className="navbar-container">
            <Navbar bg="white" variant="light" expand="xl" className="navbar">
                <Navbar.Brand href={"https://tiger.media"}>
                    <img
                        src={logo}
                        width="120"
                        height="24"
                        alt="Tigermedia Logo"
                    />{' '}
                </Navbar.Brand>
                <Navbar.Toggle aria-controls="basic-navbar-nav"/>
                <Navbar.Collapse id="basic-navbar-nav" className="justify-content-sm-end">
                    <Nav style={{textAlign: "left!important"}}>
                        <Nav.Link href={"https://tiger.media/"}><span className="navbar-link navbar-link-home">Home</span></Nav.Link>
                        <Nav.Link href={"/dashboard"}><span className="navbar-link navbar-link-dashboard">Mein&nbsp;Konto</span></Nav.Link>
                        <Nav.Link href={"/search"}><span className="navbar-link navbar-link-search">Suche</span></Nav.Link>
                        <Nav.Link href={"https://helpcenter.tiger.media/hc/de"}><span className="navbar-link navbar-link-help">Hilfe</span></Nav.Link>
                    </Nav>
                </Navbar.Collapse>
            </Navbar>
        </div>
    )
}